import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {TemplateComponentType} from '../model/template-component-type';
import {AppConfig} from '../shared/app-config';
import {environment} from '../../environments/environment';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {factory} from '../shared/app-logging';
import {ErrorDataService} from './error-data.service';

const logger = factory.getLogger('TemplateComponentTypesService');


@Injectable({
  providedIn: 'root'
})
export class TemplateComponentTypesService {
  constructor(private httpClient: HttpClient) {
  }

  public findTemplateComponentTypes(): Observable<TemplateComponentType[]> {
    return this.httpClient.get(environment.contentLibraryApiBaseUrl + AppConfig.urlTemplateDeliveryPaths).pipe(map(
      response => {
        const componentTypes = [];

        for (const item of response['data']) {
          componentTypes.push(new TemplateComponentType(item.component_type));
        }

        return componentTypes;
      }
    ), catchError((err: Error | HttpErrorResponse) => {
      const message = `In TemplateComponentTypesService.findTemplateComponentTypes().`;
      return throwError(ErrorDataService.overLoadError(err, message));
    }));
  }

}
